import { render, staticRenderFns } from "./Gestor.vue?vue&type=template&id=756eb12e"
import script from "./Gestor.vue?vue&type=script&lang=js"
export * from "./Gestor.vue?vue&type=script&lang=js"
import style0 from "./Gestor.vue?vue&type=style&index=0&id=756eb12e&prod&lang=css"
import style1 from "./Gestor.vue?vue&type=style&index=1&id=756eb12e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports